// Portado de src/pages/tratamentos/avaliacao-360.astro (site Astro).
import { CardsAtendimento } from "@/components/itv/CardsAtendimento";
import { CardsCapa } from "@/components/itv/tratamento/CardsCapa";
import { Faq } from "@/components/itv/tratamento/Faq";
import { useAgendamentoLink } from "@/lib/itv/agendamento";

const satelites = [
  { rotulo: "COMPOSIÇÃO", x: 1040, y: 46 },
  { rotulo: "METABOLISMO", x: 1239.26, y: 118.53 },
  { rotulo: "ALIMENTAÇÃO", x: 1345.29, y: 302.17 },
  { rotulo: "ATIVIDADE", x: 1308.47, y: 511 },
  { rotulo: "SONO", x: 1146.03, y: 647.3 },
  { rotulo: "HORMÔNIOS", x: 933.97, y: 647.3 },
  { rotulo: "EXAMES", x: 771.53, y: 511 },
  { rotulo: "SUPLEMENTOS", x: 734.71, y: 302.17 },
  { rotulo: "ROTINA", x: 840.74, y: 118.53 },
];

const frentes = [
  { n: "01", titulo: "Composição corporal", texto: "Bioimpedância feita na consulta: gordura, massa muscular e gordura visceral em números." },
  { n: "02", titulo: "Metabolismo", texto: "Como o seu corpo gasta e armazena energia." },
  { n: "03", titulo: "Alimentação", texto: "O que você realmente come no dia a dia, e o que dá para melhorar na sua rotina." },
  { n: "04", titulo: "Atividade física", texto: "O que você pratica hoje e o que faz sentido praticar." },
  { n: "05", titulo: "Sono", texto: "Quantidade, qualidade e o que atrapalha." },
  { n: "06", titulo: "Saúde hormonal", texto: "Investigada quando os sintomas e o caso indicam." },
  { n: "07", titulo: "Exames", texto: "Solicitados de acordo com a sua individualidade. Sem pacote pronto." },
  { n: "08", titulo: "Suplementação", texto: "O que você toma hoje e o que tem indicação real." },
  { n: "09", titulo: "Rotina e estilo de vida", texto: "Trabalho, família e a vida em que o plano precisa caber." },
];

const etapas = [
  { n: "01", titulo: "A consulta", texto: "Uma consulta longa, com espaço para a sua história: sintomas, hábitos, objetivos e tentativas anteriores." },
  { n: "02", titulo: "Os exames", texto: "Solicitados de acordo com o seu caso. Sem pacote pronto." },
  { n: "03", titulo: "O plano", texto: "As estratégias traçadas para o seu objetivo: emagrecimento, massa muscular, disposição, prevenção e longevidade." },
];

// Nota do cliente: mesmos hrefs já usados na Home para as demais páginas de
// tratamento (rota canônica de cada uma consta em src/lib/itv/site.ts / MENU).
const caminhos = [
  { badge: "Emagrecimento", titulo: "Emagrecimento e saúde metabólica", texto: "Emagrecer com acompanhamento médico, preservando massa muscular.", img: "/img/trat-1-420.webp", srcSet: "/img/trat-1-420.webp 420w, /img/trat-1-840.webp 840w", href: "/tratamentos/emagrecimento/" },
  { badge: "Saúde hormonal", titulo: "Saúde hormonal", texto: "Investigar antes de repor: masculina, feminina e implante hormonal.", img: "/img/trat-2-420.webp", srcSet: "/img/trat-2-420.webp 420w, /img/trat-2-840.webp 840w", href: "/tratamentos/saude-hormonal/" },
  { badge: "Massa muscular", titulo: "Massa muscular e sarcopenia", texto: "Para quem está perdendo músculo, ou não consegue ganhar.", img: "/img/trat-3.webp", href: "/tratamentos/massa-muscular/" },
  { badge: "Medicina do esporte", titulo: "Medicina do esporte", texto: "Performance, recuperação e as dores de quem treina.", img: "/img/trat-4.webp", href: "/tratamentos/medicina-do-esporte/" },
  { badge: "Longevidade", titulo: "Longevidade e qualidade de vida", texto: "Energia e disposição de hoje, saúde e autonomia no longo prazo.", img: "/img/trat-5.webp", href: "/tratamentos/longevidade/" },
  { badge: "Estética", titulo: "Estética e medicina regenerativa", texto: "Flacidez, gordura localizada e cuidados capilares, com Unyque Pro e Mesoject Gun.", img: "/img/trat-6.webp", href: "/tratamentos/estetica-regenerativa/" },
];

// FAQ (Figma 124:53 a 124:79). A pergunta "Preciso de pedido médico ou
// preparo?" ficou sem resposta no Figma (envolve procedimento clínico) e não
// é publicada, como no site Astro original.
export const faq = [
  { pergunta: "É um check-up?", resposta: "O check-up produz uma lista de exames. Aqui os resultados viram um plano, com acompanhamento na sequência." },
  { pergunta: "A bioimpedância é cobrada à parte?", resposta: "Não. A bioimpedância é feita durante a própria consulta e já faz parte da avaliação." },
  { pergunta: "Funciona por teleconsulta?", resposta: "Sim. A avaliação também acontece por vídeo, com os exames feitos na sua cidade. Quando for preciso exame físico, indicamos a presencial." },
  { pergunta: "O atendimento é particular?", resposta: "Sim, o atendimento é particular, tanto presencial em Bauru quanto por teleconsulta." },
];

export function Avaliacao360() {
  const agendar = useAgendamentoLink();
  return (
    <div className="pag-avaliacao360">
      <section className="hero">
        <div className="orbita" aria-hidden="true">
          <img className="orbita-anel" src="/icones/orbita-1.svg" width={620} height={620} alt="" style={{ left: 734, top: 50 }} />
          <img className="orbita-anel" src="/img/orbita-brilho.webp" width={430} height={430} alt="" style={{ left: 829, top: 145 }} />
          <img className="orbita-anel" src="/icones/orbita-2.svg" width={200} height={200} alt="" style={{ left: 944, top: 260 }} />
          <p className="orbita-360">360°</p>
          <p className="orbita-rotulo-centro">VOCÊ POR INTEIRO</p>
          {satelites.map((s) => (
            <span key={s.rotulo}>
              <img className="orbita-ponto" src="/icones/orbita-3.svg" width={40} height={40} alt="" style={{ left: s.x - 16, top: s.y - 16 }} />
              <p className="orbita-rotulo" style={{ left: s.x + 16, top: s.y - 1 }}>{s.rotulo}</p>
            </span>
          ))}
        </div>

        <div className="container hero-conteudo">
          <nav className="trilha" aria-label="Você está em">
            <a href="/">Home</a> <span aria-hidden="true">›</span> <span>Avaliação 360°</span>
          </nav>
          <p className="hero-sobretitulo">A PORTA DE ENTRADA DO CONSULTÓRIO</p>
          <h1>
            Avaliação <em>360°.</em>
          </h1>
          <p className="hero-chamada">
            Uma avaliação completa e individualizada, que busca entender você como um todo, e não apenas
            uma queixa ou um número na balança.
          </p>
          <a className="btn-ouro hero-btn" href={agendar}>
            Agendar avaliação
          </a>
        </div>
      </section>

      <section className="avaliado">
        <div className="container avaliado-inner">
          <p className="sobretitulo">O QUE É AVALIADO</p>
          <div className="avaliado-titulo">
            <h2>O corpo inteiro, em uma consulta</h2>
            <p>
              Nove frentes avaliadas na mesma consulta, para o plano nascer do seu caso, e não de um
              protocolo pronto:
            </p>
          </div>
          <ul className="avaliado-grade">
            {frentes.map((f) => (
              <li className="frente" key={f.n}>
                <p className="frente-head">
                  <span className="frente-n">{f.n}</span>
                  <span className="frente-titulo">{f.titulo}</span>
                </p>
                <p className="frente-texto">{f.texto}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="etapas">
        <div className="container etapas-inner">
          <p className="etapas-eyebrow">COMO FUNCIONA</p>
          <h2>Da avaliação ao plano</h2>
          <ol className="etapas-lista">
            {etapas.map((e) => (
              <li className="etapa" key={e.n}>
                <span className="etapa-n">{e.n}</span>
                <h3>{e.titulo}</h3>
                <p>{e.texto}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <CardsCapa
        sobretitulo="DEPOIS DA AVALIAÇÃO"
        titulo="O plano aponta o caminho"
        chamada="Conforme o que a avaliação mostrar, o acompanhamento segue em uma ou mais frentes:"
        cards={caminhos}
      />

      <Faq titulo="Antes da sua avaliação" itens={faq} />

      <section className="cta">
        <div className="container cta-inner">
          <p className="cta-eyebrow">COMECE POR AQUI</p>
          <h2>
            Uma consulta que olha o corpo inteiro e <em>sai com um plano.</em>
          </h2>
          <CardsAtendimento />
        </div>
      </section>
    </div>
  );
}
